(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["miraventa-spoilers"] && !Shopify.designMode) return;
  try {
    if (!window.miraventaSpoilersInitialized) {
    window.miraventaSpoilersInitialized = true;

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-spoiler-open]');

      if (opener) {
        const dialog =
          document.getElementById(opener.dataset.spoilerOpen);

        if (dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
        }

        return;
      }

      const closer =
        event.target.closest('[data-spoiler-close]');

      if (closer) {
        const dialog = closer.closest('dialog');

        if (dialog) {
          dialog.close();
        }

        return;
      }

      if (
        event.target.matches(
          '.miraventa-spoilers__dialog'
        )
      ) {
        event.target.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
